// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { ControlsUtils } from '../../UtilsClasses/ControlsUtils';
import { Pen, SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '../../misc/ThemeManager';
class _QuickTableUtils {
    constructor() {
        this._cachedTextHeightByFont = new Map();
    }
    DrawTextInRect(context, text, font, textBrush, x, y, width, height, xPadding = 0, yPadding = 0, truncateTextOverflow = false, searchFilter = '', backgroundBrush = null) {
        context.font = font;
        if (width < text.length * 6.2 + xPadding) {
            context.textAlign = 'start';
        }
        if (context.textAlign === 'start' || context.textAlign === 'end') {
            x = x + xPadding;
            width = width - xPadding * 2;
            y = y + yPadding;
        }
        else if (context.textAlign === 'center') {
            y = y + yPadding;
        }
        const textRectangle = new Rectangle(x, y, width, height);
        context.DrawStringInRectNew(text, textBrush, textRectangle, truncateTextOverflow);
        if (isValidString(searchFilter)) {
            context.DrawMatchStringInRect(text, textRectangle, searchFilter, new SolidBrush(ThemeManager.colors.instrumentLookupAutoCompleteFilterForeground), backgroundBrush, truncateTextOverflow);
        }
    }
    /**
     * @deprecated Use DrawTextInRect instead.
     */
    DrawTextInRectWithFont(context, text, font, textBrush, x, y, width, height, xPadding = 0, yPadding = 0, truncateTextOverflow = false) {
        if (width < text.length * 6.2 + xPadding) {
            context.textAlign = 'start';
        }
        if (context.textAlign === 'start') {
            x = x + xPadding;
            width = width - xPadding;
            y = y + yPadding;
        }
        else if (context.textAlign === 'end') {
            width = width - xPadding;
            y = y + yPadding;
        }
        else if (context.textAlign === 'center') {
            y = y + yPadding;
        }
        const textRectangle = new Rectangle(x, y, width, height);
        context.DrawStringInRect(text, font, textBrush, textRectangle, truncateTextOverflow, context.textAlign, context.textBaseline);
    }
    GetTextStartX(context, text, x, y, width, height, xPadding = 0, yPadding = 0) {
        // if (width < text.length / 5)
        //     text = text.slice(0, width / 5);
        if (width < text.length * 6.2 + xPadding + 8) {
            context.textAlign = 'start';
        }
        const textW = QuickTableUtils.GetWidth(context, text);
        if (context.textAlign === 'start') {
            return x + xPadding - textW;
        }
        else if (context.textAlign === 'end') {
            return x + width - xPadding - 8 - textW;
        }
    }
    GetWidth(context, text) {
        return ControlsUtils.GetTextWidth(text, context.font);
    }
    GetHeight(context, text) {
        const metrics = context.measureText(text);
        const ascent = metrics.actualBoundingBoxAscent || 0;
        const descent = metrics.actualBoundingBoxDescent || 0;
        return Math.round(ascent + descent);
    }
    GetTextHeight(context) {
        const font = context.font;
        const result = this._cachedTextHeightByFont.get(font);
        if (isValidNumber(result)) {
            return result;
        }
        this._cachedTextHeightByFont.set(font, this.GetHeight(context, 'A'));
        return this._cachedTextHeightByFont.get(font);
    }
    getCheckBoxDrawings(isChecked, hover, disabled) {
        let image = null;
        let backgroundBrush = null;
        let borderPen = null;
        if (isChecked) {
            if (disabled) {
                image = ThemeManager.NewImages.checkBoxIconDisabled.image;
                backgroundBrush = new SolidBrush(ThemeManager.colors.checkboxCheckedBackgroundDisabled);
                borderPen = new Pen(ThemeManager.colors.checkboxCheckedBorderDisabled);
            }
            else if (hover) {
                image = ThemeManager.NewImages.checkBoxIconHovered.image;
                backgroundBrush = new SolidBrush(ThemeManager.colors.checkboxCheckedBackgroundHovered);
                borderPen = new Pen(ThemeManager.colors.checkboxCheckedBorderHovered);
            }
            else {
                image = ThemeManager.NewImages.checkBoxIcon.image;
                backgroundBrush = new SolidBrush(ThemeManager.colors.checkboxCheckedBackground);
                borderPen = new Pen(ThemeManager.colors.checkboxCheckedBorder);
            }
        }
        else {
            if (disabled) {
                backgroundBrush = new SolidBrush(ThemeManager.colors.checkboxNotCheckedBackgroundDisabled);
                borderPen = new Pen(ThemeManager.colors.checkboxNotCheckedBorderDisabled);
            }
            else if (hover) {
                backgroundBrush = new SolidBrush(ThemeManager.colors.checkboxNotCheckedBackgroundHovered);
                borderPen = new Pen(ThemeManager.colors.checkboxNotCheckedBorderHovered);
            }
            else {
                backgroundBrush = new SolidBrush(ThemeManager.colors.checkboxNotCheckedBackground);
                borderPen = new Pen(ThemeManager.colors.checkboxNotCheckedBorder);
            }
        }
        return { image, backgroundBrush, borderPen };
    }
}
export const QuickTableUtils = new _QuickTableUtils();
